import { forwardRef, Heading, HeadingProps } from '@chakra-ui/react';

export const H5 = forwardRef<HeadingProps, 'h5'>((props, ref) => {
    return <Heading as="h5" size="h5" ref={ref} {...props} />;
});
